import de from './translations/de/common.json';
import en from './translations/en/common.json';
import es from './translations/es/common.json';
import fr from './translations/fr/common.json';
import it from './translations/it/common.json';
import ja from './translations/ja/common.json';
import nl from './translations/nl/common.json';
import nn from './translations/nn/common.json';
import zh from './translations/zh/common.json';

export default {
  de: { common: de },
  en: { common: en },
  es: { common: es },
  fr: { common: fr },
  it: { common: it },
  ja: { common: ja },
  nl: { common: nl },
  nn: { common: nn },
  zh: { common: zh },
};
